  import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
  import { Component, OnInit } from '@angular/core';
  import { Observable } from 'rxjs';
  import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
  import { PipelineGradeDto } from '@cradua/data';
  import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';
  
  @Component({
    selector: 'cradua-pipelinegrade-container',
    templateUrl: './pipelinegrade-container.component.html',
    styleUrls: ['./pipelinegrade-container.component.scss']
  })
  export class PipelinegradeContainerComponent implements OnInit {
  
    routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
    pipelinegrades$: Observable<PipelineGradeDto[]>;
    loading: boolean;
    isLoadingPipelinegrade$: Observable<boolean>;
    constructor(
      private gatwayFacade: GatewayFacade,
    ) {}
  
    ngOnInit() {
      this.isLoadingPipelinegrade$ = this.gatwayFacade.isLoadingGateway("PipelineGrade");
      this.pipelinegrades$ = this.gatwayFacade.loadGateway("PipelineGrade");
    }
  
  /**
   this method dispatches array of ids to the effects,
   which handle the sending of data asynchronously
    */
  
    onDeletePipelinegrade(deletedValue: any) {
      this.gatwayFacade.remove("PipelineGrade", deletedValue);
    }
  
  
  // this method control both the create and update
  
    onSubmitPipelinegrade(formValue: any) {
      // event.preventDefault();
      const pullData = formValue.Pipelinegrades;
  
  // declare two empty arrays to hold update and create data
    const allUpdates = [] ;
    const addAllPipelinegrade = [];
  
  
  // loop through the form data to check for update and create
    for(let i = 0; i < pullData.length; i++) {
      if(pullData[i].id !== null) {
        allUpdates.push(pullData[i]);
      } else {
        delete pullData[i].id;
        addAllPipelinegrade.push(pullData[i]);
      }
    }
  
  // check if the addAllPipelinegrade array is not empty, then dispatch the data to the store
     if(addAllPipelinegrade.length > 0) {
      this.gatwayFacade.add('PipelineGrade', addAllPipelinegrade);
     }
  
     if(allUpdates.length > 0) {
       // dispatch update data to the store
      this.gatwayFacade.update('PipelineGrade', allUpdates, ['id']);
    }
  
     }
  
  
  }
  